import { ref } from 'vue'

const STORAGE_KEY = 'nav-saved-places'

// Singleton a nivel de módulo — compartido entre TransporteBuscador y SalidaNavModal
const places = ref(_load())

function _load() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') } catch { return [] }
}

function _persist() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(places.value))
}

export function useSavedPlaces() {
  const add = (name, lat, lng) => {
    places.value = [...places.value, { name, lat, lng }]
    _persist()
  }

  const remove = (idx) => {
    places.value = places.value.filter((_, i) => i !== idx)
    _persist()
  }

  return { places, add, remove }
}
